import React from 'react';

interface ProtectedEmailProps {
  email: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const ProtectedEmail: React.FC<ProtectedEmailProps> = ({ 
  email, 
  className = '', 
  style = {},
  children 
}) => {

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(email);
      // You could add a toast notification here
      alert('Email đã được sao chép!');
    } catch (err) {
      console.error('Failed to copy email:', err);
    }
  };

  return (
    <span className={className} style={style}>
      <a 
        href={`mailto:${email}`}
        style={{ color: 'inherit', textDecoration: 'underline' }}
      >
        {children || email}
      </a>
      <button
        onClick={handleCopy}
        style={{
          marginLeft: '0.5rem',
          padding: '0.25rem 0.5rem',
          fontSize: '0.8rem',
          backgroundColor: 'transparent',
          border: '1px solid currentColor',
          borderRadius: '3px',
          cursor: 'pointer',
          color: 'inherit'
        }}
        title="Sao chép email"
      >
        📋
      </button>
    </span>
  );
};

export default ProtectedEmail;